import React from 'react'

/**
 * BreathingBadgeDot
 * -----------------
 * Soft pulsating / breathing dot indicator matching the live status indicator
 * on the Resource Allocation 'Today' badge.
 */
export default function BreathingBadgeDot({ color = 'rose', className = '', ...props }) {
  const colorMap = {
    rose: {
      ping: 'bg-rose-400',
      dot: 'bg-rose-500',
      shadow: 'shadow-rose-500/50',
    },
    emerald: {
      ping: 'bg-emerald-400',
      dot: 'bg-emerald-500',
      shadow: 'shadow-emerald-500/50',
    },
    amber: {
      ping: 'bg-amber-400',
      dot: 'bg-amber-500',
      shadow: 'shadow-amber-500/50',
    },
  }

  const selected = colorMap[color] || colorMap.rose

  return (
    <span
      className={`relative inline-flex items-center justify-center h-2.5 w-2.5 shrink-0 ${className}`}
      {...props}
    >
      <span className={`animate-ping absolute inline-flex h-full w-full rounded-full ${selected.ping} opacity-75`} />
      <span className={`relative inline-flex rounded-full h-2 w-2 ${selected.dot} shadow-xs ${selected.shadow}`} />
    </span>
  )
}
